import React, { useState } from 'react';
import { supabase } from '../lib/supabase';

export default function DataRequestPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [requestType, setRequestType] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await supabase.from('partner_requests').insert({
        full_name: name,
        email,
        category: 'data_request',
        message: `Request Type: ${requestType}\n${message}`,
      });
      setSubmitted(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0a0f1a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 24px', fontFamily: 'Barlow, sans-serif' }}>
      <div style={{ maxWidth: 560, width: '100%' }}>
        <a href="/" style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', textDecoration: 'none', display: 'block', marginBottom: 32 }}>← Back to bthd.app</a>
        
        <div style={{ fontFamily: 'Barlow Condensed, sans-serif', fontWeight: 900, fontSize: 32, color: '#fff', marginBottom: 8 }}>
          Data Request
        </div>
        <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', marginBottom: 40, lineHeight: 1.6 }}>
          Under Canadian privacy law (PIPEDA), you have the right to access, correct, or request deletion of your personal data. Complete the form below and we'll respond within 30 days.
        </div>

        {submitted ? (
          <div style={{ background: 'rgba(15,168,109,0.1)', border: '1px solid rgba(15,168,109,0.3)', borderRadius: 12, padding: 32, textAlign: 'center' }}>
            <div style={{ fontSize: 24, marginBottom: 12 }}>✓</div>
            <div style={{ color: '#0fa86d', fontWeight: 700, fontSize: 16, marginBottom: 8 }}>Request Received</div>
            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>We'll respond to your request within 30 days at the email provided.</div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.5)', letterSpacing: 1, marginBottom: 8, textTransform: 'uppercase' }}>Full Name *</label>
              <input
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                required
                placeholder="Your full name"
                style={{ width: '100%', padding: '14px 16px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.05)', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
              />
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.5)', letterSpacing: 1, marginBottom: 8, textTransform: 'uppercase' }}>Email Address *</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                placeholder="your@email.com"
                style={{ width: '100%', padding: '14px 16px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.05)', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
              />
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.5)', letterSpacing: 1, marginBottom: 8, textTransform: 'uppercase' }}>Request Type *</label>
              <select
                value={requestType}
                onChange={e => setRequestType(e.target.value)}
                required
                style={{ width: '100%', padding: '14px 16px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.1)', background: '#0a0f1a', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
              >
                <option value="">Select request type</option>
                <option value="access">Access my data</option>
                <option value="correction">Correct my data</option>
                <option value="deletion">Delete my data</option>
                <option value="opt-out">Opt out of AI processing</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div style={{ marginBottom: 32 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.5)', letterSpacing: 1, marginBottom: 8, textTransform: 'uppercase' }}>Additional Details</label>
              <textarea
                value={message}
                onChange={e => setMessage(e.target.value)}
                placeholder="Please provide any additional context..."
                rows={4}
                style={{ width: '100%', padding: '14px 16px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.05)', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box', resize: 'vertical' }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{ width: '100%', padding: 16, borderRadius: 10, background: loading ? '#666' : '#bf1e2e', border: 'none', color: '#fff', fontFamily: 'Barlow Condensed, sans-serif', fontWeight: 700, fontSize: 16, letterSpacing: 1, cursor: 'pointer' }}
            >
              {loading ? 'Submitting...' : 'SUBMIT REQUEST'}
            </button>
          </form>
        )}

        <div style={{ marginTop: 48, borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 40 }}>
          <div style={{ fontFamily: 'Barlow Condensed, sans-serif', fontWeight: 900, fontSize: 22, color: '#bf1e2e', marginBottom: 8 }}>
            Delete Your Account
          </div>
          <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', marginBottom: 20, lineHeight: 1.6 }}>
            If you have the BTHD app, you can delete your account directly in <strong style={{ color: 'rgba(255,255,255,0.7)' }}>Settings → Delete Account</strong>.
            Your account will be permanently deleted within 30 days, including all profile data, assessment responses, messages, and AI usage records.
          </div>
          <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', lineHeight: 1.6 }}>
            No app access? Select <strong style={{ color: 'rgba(255,255,255,0.7)' }}>"Delete my data"</strong> in the form above and we will process your deletion request within 30 days.
          </div>
        </div>

        <div style={{ marginTop: 32, fontSize: 11, color: 'rgba(255,255,255,0.25)', textAlign: 'center', lineHeight: 1.6 }}>
          Bigger Than Hoop Dreams Inc. · harry@bthd.app · bthd.app
        </div>
      </div>
    </div>
  );
}
